import React, { useEffect, useRef, useState } from "react";
import Image from "next/image";
import { useDetailContext } from "@/context/detailContext";
import dynamic from "next/dynamic";

const GuestSelectorDropdown = dynamic(() => import("./GuestSelectorDropdown"), {
  ssr: false,
});

const GuestSelector = () => {
  const { setEnquiryForm } = useDetailContext();
  const [selectedGuests, setSelectedGuests] = useState({
    adults: 2,
    children: 0,
    infants: 0,
  });
  const guestsRefdropdownRef = useRef(null);
  const refOne = useRef(null);
  const [guestOpen, setGuestOpen] = useState(false);

  const updateGuests = (type, increment) => {
    setSelectedGuests((prev) => ({
      ...prev,
      [type]: Math.max(0, prev[type] + (increment ? 1 : -1)),
    }));
  };
  const displayText = `${selectedGuests.adults} Yetişkin, ${selectedGuests.children} Çocuk`;

  useEffect(() => {
    setEnquiryForm((prev) => {
      return {
        ...prev,
        yetiskin: selectedGuests.adults,
        cocuk: selectedGuests.children,
        bebek: selectedGuests.infants,
      };
    });
  }, [selectedGuests, setEnquiryForm]);

  return (
    <div ref={guestsRefdropdownRef} className="relative">
      <div
        ref={refOne}
        onClick={() => setGuestOpen(!guestOpen)}
        className="flex items-center rounded-lg cursor-pointer border border-[#E7EDF4] bg-white py-4 px-5"
      >
        <div className="flex items-center gap-5">
          <span className="text-sm font-medium leading-normal text-themeBreadcrumColor">
            {displayText || "Seçiniz"}
          </span>
        </div>
        <Image
          src="/icons/down.svg"
          width={12}
          height={12}
          alt="icon"
          className="ml-auto"
        />
      </div>
      {guestOpen && (
        <GuestSelectorDropdown
          setGuestOpen={setGuestOpen}
          selectedGuests={selectedGuests}
          setSelectedGuests={setSelectedGuests}
          updateGuests={updateGuests}
          refOne={refOne}
        />
      )}
    </div>
  );
};

export default GuestSelector;
